// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;68</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;Let God arise and let his enemies be scattered;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;let those that hate him flee before him.<br> </p> </div></div>";
// Exports
module.exports = code;